﻿(function($, window){

	$.widget('lb.lazyload', {
		options: {
			images: $([]),
			animation: 'fadeIn',
			animationSpeed: 200
		},
					
		_init: function(){
			var self = this;
			self._populateImages();
			self._load();
		},
					
		_create: function(){
			var self = this,
				$window = $(window)
							.scroll(function(e){
								self._load.apply(self, []);
							});	
							
			if ((/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
				$window.bind('pageshow', function (event) {
					if (event.originalEvent.persisted) {
						self._load();
					}
				});
			}
		},
										
		_populateImages: function(){
			var self = this
			self.options.images = self.element.find('img[data-lazy-url]');						
			return self;
		},
					
		_load: function() {
			var self = this;
						
			if(self.options.images.length === 0) { return; }
						
			self.options.images
				.filter(function(i){
					return !$(this).is(':below-the-fold');
				}).each(function(i, n) {							
					var img = $(n),
						src = img.data('lazyUrl');								
					img.hide()
						.attr('src', src)
						.data('loaded', true)
						[self.options.animation](self.animationSpeed);
				});
						
			self.options.images = self.options.images.filter(function(i){
				return !$(this).data('loaded');
			});
		}
	});

})(jQuery, window, undefined);
